import React, { useRef, useState, useEffect } from "react";
import { Title, BoxList, StandardCloseButton } from "../index";
import { core, store } from "../../state";
import { useHistory } from "react-router-dom";
import {
  SubMenuStyle,
  SubMenuContainerStyle,
  SubMenuTitleContainerStyle,
  SubMenuObjectiveContainerStyle,
  SubMenuObjectiveTextStyle,
  SubMenuSectionStyle,
  SubMenuBoxItemContainerStyle,
  CloseButtonContainer,
  SubMenuWrapper,
} from "./SubMenu.style";
import { Media, MediaImage, MenuBox } from "../../types";
import StandardCloseButtonComponent from "../StandardCloseButton/StandardCloseButton.component";

interface Props {
  parentBox: MenuBox;
  triggerOverlay: (value: boolean) => void;
}

const SubMenu: React.FC<Props> = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [boxWidth, setBoxWidth] = useState(0);
  const history = useHistory();
  useEffect(() => {
    props.triggerOverlay(true);
    if (boxWidth === 0) {
      setBoxWidth(ref.current ? ref.current.offsetHeight : 0);
    }
  }, [ref]);
  const onClickClose = () => {
    if (store.currentBox) {
      const parentBox = core.getBoxParent(store.currentBox.id, store.content.boxList);
      history.push(parentBox ? `/box?idBox=${parentBox.id}` : "/");
    }
    props.triggerOverlay(false);
  };

  return (
    <SubMenuStyle className={"submenu"}>
      <SubMenuWrapper className={"submenu-wrapper"}>
        <SubMenuSectionStyle className={"submenu-section"}>
          <SubMenuContainerStyle
            bg={props.parentBox.menuBackground}
            autoWidth={boxWidth}
            ref={ref}
            className={"submenu-container"}
          >
            <CloseButtonContainer className="sub-menu-close-button-container">
              <StandardCloseButtonComponent onClick={onClickClose} />
            </CloseButtonContainer>
            <SubMenuTitleContainerStyle className={"submenu-title-container"}>
              <Title
                customClass={"submenu-title"}
                fontColor={props.parentBox.titleColor || props.parentBox.primaryColor}
                level={2}
              >
                {props.parentBox.title}
              </Title>
            </SubMenuTitleContainerStyle>
            {props.parentBox.objectiveText && (
              <SubMenuObjectiveContainerStyle className={"submenu-objective-container"}>
                <SubMenuObjectiveTextStyle className={"submenu-objective"}>
                  {props.parentBox.objectiveText}
                </SubMenuObjectiveTextStyle>
              </SubMenuObjectiveContainerStyle>
            )}
            <SubMenuBoxItemContainerStyle className={"submenu-boxlist-container"}>
              <BoxList boxList={props.parentBox.boxList}></BoxList>
            </SubMenuBoxItemContainerStyle>
          </SubMenuContainerStyle>
        </SubMenuSectionStyle>
      </SubMenuWrapper>
    </SubMenuStyle>
  );
};

export default SubMenu;
